import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigApiService } from '@core/services/api/app-config-api.service';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  private readonly configApi = inject(AppConfigApiService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const apiBaseUrl = this.configApi.getApiBaseUrl();
    const isAbsoluteUrl = /^https?:\/\//i.test(request.url);
    const shouldPrefixApiUrl = request.url.startsWith('/api') || request.url.startsWith('api/');

    const requestToHandle =
      !isAbsoluteUrl && shouldPrefixApiUrl
        ? request.clone({
            url: request.url.startsWith('/')
              ? `${apiBaseUrl}${request.url.slice(4)}`
              : `${apiBaseUrl}/${request.url.slice(4)}`,
            setHeaders: {
              'X-App-Client': 'veredis-ai-app',
            },
          })
        : request.clone({
            setHeaders: {
              'X-App-Client': 'veredis-ai-app',
            },
          });

    return next.handle(requestToHandle);
  }
}
